module.exports = __webpack_public_path__ + "img/soundNotPlayed.ef14f37c.svg";